import AboutPopup from "@/components/about-popup";
import AddSitePopup from "@/components/add-site-popup";
import AiBar from "@/components/ai-bar";
import Analytics from "@/components/analytics";
import ApiKeysPopup from "@/components/api-keys-popup";
import ContextMenu from "@/components/context-menu";
import CornerActions from "@/components/corner-actions";
import FileList from "@/components/file-list";
import FloatNotification from "@/components/float-notification";
import Header from "@/components/header";
import LoadingScreen from "@/components/loading-screen";
import LoginPanel from "@/components/login-panel";
import MainMenu from "@/components/main-menu";
import MessageDialog from "@/components/message-dialog";
import NavigationBar from "@/components/navigation-bar";
import PromptPopup from "@/components/prompt-popup";
import SettingsPopup from "@/components/settings-popup";
import SiteList from "@/components/site-list";
import SplashScreen from "@/components/splash-screen";
import SslPopup from "@/components/ssl-popup";
import Toast from "@/components/toast";
import UploadCenter from "@/components/upload-center";
import * as signals from "@/signals";
import { JSX } from "react";

function App(): JSX.Element {
	return (
		<>
			<Header />
			<SiteList />
			<FileList />
			{signals.isAiBarShown.value && <AiBar />}
			{signals.pendingUploadFiles.value.length > 0 && <UploadCenter />}
			<NavigationBar />
			<CornerActions />
			{signals.isLoginPanelShown.value && <LoginPanel />}
			{(signals.isSplashScreenShown.value ||
				(signals.isLoadingShown.value &&
					signals.sites.value.length === 0)) && <SplashScreen />}
			{signals.floatNotificationInfo.value && <FloatNotification />}
			{signals.isMainMenuShown.value && <MainMenu />}
			{signals.arePopupsOpen.value.about && <AboutPopup />}
			{signals.arePopupsOpen.value.addSite && <AddSitePopup />}
			{signals.arePopupsOpen.value.settings && <SettingsPopup />}
			{signals.arePopupsOpen.value.apiKeys && <ApiKeysPopup />}
			{signals.arePopupsOpen.value.ssl && <SslPopup />}
			{signals.prompt.value.text && <PromptPopup />}
			{signals.dialog.value.text && <MessageDialog />}
			{signals.contextMenuInfo.value && <ContextMenu />}
			{signals.isLoadingShown.value && signals.sites.value.length > 0 && (
				<LoadingScreen />
			)}
			<Toast />
			<Analytics />
		</>
	);
}

export default App;
